import VehicleCluster from './VehicleCluster'

export default VehicleCluster
